export const COLOR_PRIMARY = 'primary';
export const COLOR_SECONDARY = 'secondary';
export const COLOR_TERTIARY = 'tertiary';

export const COLOR_ORDINALS = [
  COLOR_PRIMARY,
  COLOR_SECONDARY,
  COLOR_TERTIARY,
];

export const BLACK_HEX = '#000000';
export const WHITE_HEX = '#ffffff';

export const validateHexCode = value => (
  /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value)
);
